import type { CoreShellPorts } from '../../routing/domain/CoreShellPorts.ts';

export type ShellNavPermissionErrorSource = 'dashboard.syncNav' | 'sidebar.syncNav';
/** Report shell nav permission load failure. */


export function reportShellNavPermissionLoadFailure(
  shellPorts: Pick<CoreShellPorts, 'telemetry' | 'notifications'>,
  source: ShellNavPermissionErrorSource,
  userMessage: string,
  err: unknown,
): void {
  shellPorts.telemetry.logError(err instanceof Error ? err.message : String(err), { source, error: err });
  shellPorts.notifications.warning(userMessage);
}
